export default __webpack_public_path__ + "static/media/cpLaundryPassNewsPinkBm.4fc70347.jpg";